module.exports = __webpack_public_path__ + "logo.71d742f0.jpg";